import React, { Component } from "react";
import {  Redirect } from "react-router-dom";
import BACKEND_URL from '../../config';

class NewEmployee extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      first_name: "",
      last_name: "",
      dob: "",
      department: "",
      position: "",
      address: "",
      email: "",
      phone: "",
      hire_date: "",
      url: "",
      redirectAdmin: false
    };
  }
  handleSubmit = (event) => {
    event.preventDefault();
    const data = {
      ...this.state
    };
    fetch(`${BACKEND_URL}/employees`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data)
    })
      .then(function(response) {
        console.log(`400  ${response}`);
        if (response.status >= 400) {
          throw new Error("Bad response from server");
        }
        return response.json();
      })
      .then((data) => {
        if (data) {
          this.setState({ redirectAdmin: true });
        }
      })
      .catch(function(err) {
        console.log(err);
      });
  }

  logChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  }

  render = () => {
    if (this.state.redirectAdmin) {
      return <Redirect to="/" />;
    }

    return (
      <main className="pa4 black-80">
        <form
          className="measure center"
          onSubmit={this.handleSubmit}
          method="POST"
        >
          <fieldset id="sign_up" className="ba b--transparent ph0 mh0">
            <legend className="f4 fw6 ph0 mh0">New Employee</legend>
            <div className="mt3">
              <label className="db fw6 lh-copy f6" htmlFor="first_name">
                First Name
              </label>
              <input
                className="pa2 input-reset ba bg-transparent hover-bg-black hover-white w-100"
                type="text"
                name="first_name"
                id="first_name"
                value={this.state.first_name}
                onChange={this.logChange}
              />
            </div>
            <div className="mt3">
              <label className="db fw6 lh-copy f6" htmlFor="last_name">
                Last Name
              </label>
              <input
                className="pa2 input-reset ba bg-transparent hover-bg-black hover-white w-100"
                type="text"
                name="last_name"
                id="last_name"
                value={this.state.last_name}
                onChange={this.logChange}
              />
            </div>
            <div className="mt3">
              <label className="db fw6 lh-copy f6" htmlFor="dob">
                DOB
              </label>
              <input
                className="pa2 input-reset ba bg-transparent hover-bg-black hover-white w-100"
                type="date"
                name="dob"
                id="dob"
                value={this.state.dob}
                onChange={this.logChange}
              />
            </div>
            <div className="mt3">
              <label className="db fw6 lh-copy f6" htmlFor="department">
                Department
              </label>
              <input
                className="pa2 input-reset ba bg-transparent hover-bg-black hover-white w-100"
                type="text"
                name="department"
                id="department"
                value={this.state.department}
                onChange={this.logChange}
              />
            </div>
            <div className="mt3">
              <label className="db fw6 lh-copy f6" htmlFor="position">
                Position
              </label>
              <input
                className="pa2 input-reset ba bg-transparent hover-bg-black hover-white w-100"
                type="text"
                name="position"
                id="position"
                value={this.state.position}
                onChange={this.logChange}
              />
            </div>
            <div className="mt3">
              <label className="db fw6 lh-copy f6" htmlFor="address">
                Address
              </label>
              <input
                className="pa2 input-reset ba bg-transparent hover-bg-black hover-white w-100"
                type="text"
                name="address"
                id="address"
                value={this.state.address}
                onChange={this.logChange}
              />
            </div>
            <div className="mt3">
              <label className="db fw6 lh-copy f6" htmlFor="email">
                Email
              </label>
              <input
                className="pa2 input-reset ba bg-transparent hover-bg-black hover-white w-100"
                type="email"
                name="email"
                id="email"
                value={this.state.email}
                onChange={this.logChange}
              />
            </div>
            <div className="mt3">
              <label className="db fw6 lh-copy f6" htmlFor="phone">
                Phone
              </label>
              <input
                className="pa2 input-reset ba bg-transparent hover-bg-black hover-white w-100"
                type="tel"
                name="phone"
                id="phone"
                value={this.state.phone}
                onChange={this.logChange}
              />
            </div>
            <div className="mt3">
              <label className="db fw6 lh-copy f6" htmlFor="hire_date">
                Hire date
              </label>
              <input
                className="pa2 input-reset ba bg-transparent hover-bg-black hover-white w-100"
                type="date"
                name="hire_date"
                id="hire_date"
                value={this.state.hire_date}
                onChange={this.logChange}
              />
            </div>
            <div className="mt3">
              <label className="db fw6 lh-copy f6" htmlFor="url">
                Avatar url
              </label>
              <input
                className="pa2 input-reset ba bg-transparent hover-bg-black hover-white w-100"
                type="url"
                name="url"
                id="url"
                value={this.state.url}
                onChange={this.logChange}
              />
            </div>
          </fieldset>
          <div className="">
            <input
              className="b ph3 pv2 input-reset ba b--black bg-transparent grow pointer f6 dib"
              type="submit"
              value="Create"
            />
          </div>
        </form>
      </main>
    );
  }
}

export default NewEmployee;



// WEBPACK FOOTER //
// ./src/components/employee/NewEmployee.js